import { useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetFeedDto, queryKeys, useAccessToken } from "src/http";

const useGetTeamFeedRequest = (teamSlug: string | undefined) => {
  const { getAccessToken } = useAccessToken();

  async function getTeamFeedRequest(): Promise<GetFeedDto> {
    const accessToken = await getAccessToken();

    const response = await fetch(`${configuration.apiRootUrl}/teams/${teamSlug}/feed`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getTeamFeedRequest };
};

const useGetTeamFeed = (teamGuid: string | undefined, teamSlug: string | undefined) => {
  const { getTeamFeedRequest } = useGetTeamFeedRequest(teamSlug);

  return useQuery({
    queryKey: queryKeys.teams.getTeamFeed(teamGuid),
    queryFn: getTeamFeedRequest,
    enabled: teamGuid !== undefined && teamSlug !== undefined,
  });
};

export { useGetTeamFeed };
